import React, { FC } from 'react'
import SALink from 'components/SALink'
import { slugify } from 'lib/slugify'
import { getLinkCategory } from '../../helpers'
import styles from './RelatedSearches.module.scss'
import { useSelector } from 'react-redux'
import { getArtworkCategory, getArtworkKeywords } from '../../selectors/artwork'
import { getCurrentProductType } from '../../selectors/product'

const RelatedSearches: FC = () => {
  const category = useSelector(getArtworkCategory)
  const keywords = useSelector(getArtworkKeywords)
  const productType = useSelector(getCurrentProductType)

  const reservedKeywordArray = [
    'artwork',
    'artworks',
    'digital',
    'drawing',
    'drawings',
    'painting',
    'paintings',
    'photo',
    'photograph',
    'photographs',
    'photography',
    'photos',
    'printmaking',
    'sculpture',
    'sculptures',
  ]
  const linkCategory = getLinkCategory(category)

  const getKeywordHref = (keyword) => {
    if (reservedKeywordArray.includes(slugify(keyword))) {
      return `/${slugify(linkCategory)}`
    } else if (keyword === 'print' || keyword === 'prints') {
      return `/prints`
    } else if (productType === 'print') {
      return `/prints/${slugify(linkCategory)}/${slugify(keyword)}/feature`
    } else return `/${slugify(linkCategory)}/${slugify(keyword)}/feature`
  }

  return (
    <div className={styles.relatedSearchesContainer}>
      <h4>Related Searches</h4>
      {keywords.length && (
        <div>
          {(keywords || []).map((keyword) => (
            <SALink
              key={keyword}
              href={getKeywordHref(keyword)}
              title={`${keyword} ${linkCategory}`}
            >
              <p>{keyword}</p>
            </SALink>
          ))}
        </div>
      )}
    </div>
  )
}

export default RelatedSearches
